import { useMe } from '@core/hooks/use-me.js';
import { useReleaseToggle } from '@core/hooks/use-release-toggle.js';
import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ToolFrame } from '../app/tool-frame.js';
import { SpeciesSection } from '../features/projects/detail/species/species-section.js';

function SpeciesCheckerRoute() {
  const me = useMe();
  const enabled = useReleaseToggle('species_checker');
  // Fail closed only once /me resolved — the toggle reads false while loading.
  if (me.isLoading) return null;
  if (!enabled) {
    // A dark feature's deep link behaves like an unknown URL (the catch-all
    // route's redirect).
    return <Navigate to="/login" replace />;
  }
  return <ToolFrame toolSlug="species-checker" Section={SpeciesSection} requiresReport />;
}

export const Route = createFileRoute(
  '/_authed/teams/$teamId/projects/$projectId/species-checker',
)({
  component: SpeciesCheckerRoute,
});
